import React from "react"
import store from '../store';
import defaultGameSettings from '../defaultGameSettings';
import VoicePicker from './VoicePicker';

export default class GameSettings extends React.Component {
  static defaultProps = {
    gameSettings: defaultGameSettings
  }

  constructor(props) {
    super(props);
    this.state = {
      // Opens on every challenge until the player closes it once. Nothing else
      // surfaces these options, so a panel that only ever appears on request is
      // a panel nobody finds.
      expanded: props.gameSettings.settingsDismissed !== true,
      showVoicePicker: false,
      voices: store.getState().voices,

      ttsVoice: props.gameSettings.ttsVoice,
      autoPlayTts: props.gameSettings.autoPlayTts,
      soundEffects: props.gameSettings.soundEffects,
      // Stored rows predate these settings, so absent means on.
      colorHints: props.gameSettings.colorHints !== false,
      caseSensitive: props.gameSettings.caseSensitive !== false,
      settingsDismissed: props.gameSettings.settingsDismissed === true
    };
  }

  componentDidMount() {
    store.subscribe(() => this.setState({ voices: store.getState().voices }));
  }

  saveAndUpdate() {
    const { updateGameSettingsPath, onUpdate } = this.props;
    const s = this.state;
    const gameSettings = {
      ttsVoice: s.ttsVoice,
      autoPlayTts: s.autoPlayTts,
      soundEffects: s.soundEffects,
      colorHints: s.colorHints,
      caseSensitive: s.caseSensitive,
      settingsDismissed: s.settingsDismissed
    };
    onUpdate(gameSettings);

    if(!updateGameSettingsPath) {
      return false;
    }

    // send to server and trigger update
    $.ajax({
      headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
      url: updateGameSettingsPath,
      method: 'post',
      data: { game_settings: JSON.stringify(gameSettings) }
    });
  }

  // Closing the panel is what records the dismissal, so it stops opening by
  // itself from the next challenge on. Persisted rather than kept in the tab,
  // because the point is that it doesn't come back.
  dismiss() {
    const alreadyDismissed = this.state.settingsDismissed;
    this.setState({ expanded: false, settingsDismissed: true }, () => {
      // Only the first close needs saving; after that it's already recorded and
      // a request per close would be noise.
      if(!alreadyDismissed) {
        this.saveAndUpdate();
      }
    });
  }

  onCheckboxChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    }, () => this.saveAndUpdate());
  }

  // Shows the current choice and defers the list to a modal. A name in a
  // dropdown says nothing about how a voice sounds, so choosing one only really
  // works by listening — and the list is long enough to crowd out the rest of
  // this panel.
  renderTtsVoices() {
    return (
      <div>
        <div className="d-flex justify-content-between align-items-center">
          <span>{this.state.ttsVoice || 'Automatic'}</span>
          <button
            type="button"
            className="btn btn-sm btn-outline-light ml-2"
            onClick={() => this.setState({ showVoicePicker: true })}
          >
            Change
          </button>
        </div>
        <small className="text-muted">Provided by your browser and device</small>
      </div>
    );
  }

  renderVoicePicker() {
    if(!this.state.showVoicePicker) {
      return null;
    }
    return (
      <VoicePicker
        voices={this.state.voices}
        selected={this.state.ttsVoice}
        sampleText={this.props.sampleText}
        twoLetterLanguageCode={this.props.twoLetterLanguageCode}
        languageEnglishName={this.props.languageEnglishName}
        onSelect={(ttsVoice) => this.setState({ ttsVoice }, () => this.saveAndUpdate())}
        onHidden={() => this.setState({ showVoicePicker: false })}
      />
    );
  }

  render() {
    if(!this.state.expanded) {
      return (
        <div style={{ position: 'fixed', bottom: 10, right: 10, zIndex: 999 }}>
          <button onClick={() => this.setState({ expanded: true })} className="btn btn-secondary btn-sm">Settings</button>
        </div>
      );
    }

    return (
      <>
      {/* Rendered outside the panel: the fixed wrapper below sets z-index 999,
          which is a stacking context, and Bootstrap's backdrop sits at 1040 —
          a modal nested inside would be painted underneath it and be unusable. */}
      {this.renderVoicePicker()}
      <div style={{ position: 'fixed', bottom: 10, right: 10, zIndex: 999 }}>
        <div className="card text-white mb-0 bg-dark">
          <div className="card-header">
            Settings
            <button type="button" className="close text-white" aria-label="Close" onClick={() => this.dismiss()}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="card-body">
            <ul className="list-unstyled mb-0">
              {/* Not a <label>: this row is a button now, and a label wrapping
                  a button forwards clicks to it. */}
              <li className="mb-2">Text-to-speech voice{this.renderTtsVoices()}</li>
              <li><label><input name="autoPlayTts" type="checkbox" checked={this.state.autoPlayTts} onChange={this.onCheckboxChange.bind(this)} /> Auto-play audio</label></li>
              <li><label><input name="soundEffects" type="checkbox" checked={this.state.soundEffects} onChange={this.onCheckboxChange.bind(this)} /> Sound effects</label></li>
              <li><label><input name="colorHints" type="checkbox" checked={this.state.colorHints} onChange={this.onCheckboxChange.bind(this)} /> Color hints while typing</label></li>
              <li><label><input name="caseSensitive" type="checkbox" checked={this.state.caseSensitive} onChange={this.onCheckboxChange.bind(this)} /> Case sensitive</label></li>
              {/* Dark mode moved out of game settings onto the site-wide theme
                  control (footer and Settings page), so it applies everywhere
                  rather than only the game pages. */}
            </ul>
          </div>
        </div>
      </div>
      </>
    );
  }
}
